import { UserProfileModel } from 'lib/ng2-sapmp/src/models/userprofile/user-profile.model';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { UserWizardService } from 'lib/ng2-sapmp/src/providers';
import { HttpClient } from '@angular/common/http';
import { StepIndicatorService } from 'lib/ng2-sapmp/src/ui-components/step-indicator';
import { BreadCrumbModel } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { AuthenticationService, UtilityService, ValidationService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { UserModel } from './../shared';
import { UserWizardModel } from 'lib/ng2-sapmp/src/models';
import { UserWizardDataService } from './../users-wizard-data-service';
import {
  GridOptionsModel, ColumnDefinitionsModel, PaginationsModel,
  FetchCriteriaModel
} from 'lib/ng2-sapmp/src/ui-components/custom-grid';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components';
import { ANALYTICS_CONSTANTS, PIVOTS, ASSIGN_USER_LIMIT } from 'config';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot/mobile-pivot.model';

declare var ENV_VAR: any; // global variable set in env.js file, imported in index.html
declare var logoutCurrentUser: any;

@Component({
  selector: 'app-manage-users-users',
  providers: [UserWizardDataService, AdobeAnalyticsService],
  templateUrl: './users.component.html',
  styleUrls: ['./../manage-users.component.scss']
})
export class UsersComponent implements OnInit, OnDestroy {
  breadCrumbs: BreadCrumbModel[];
  userWizardInfo: UserWizardModel;
  userList: Array<UserModel>;
  selectedUserList: Array<UserModel>;
  selectedUsersIds = [];
  gridOptions: GridOptionsModel;
  continueDisable = true;
  totalLisence = 0;
  totalUser = 0;
  selectedProdDetails: any;
  serviceClientIds: any;
  showProductInfo: boolean;
  noOfSelectedProduct: number;
  requestObj: any;
  setError: boolean;
  ErrorMessage: string;
  dcmCodesSelectedProd: Array<string>;
  pivots: Array<MobilePivotModel>;
  user: UserProfileModel;
  actionType: any;
  checkLicense = 0;
  columnDefinitions: Array<ColumnDefinitionsModel> = [
    {
      caption: 'User',
      field: 'firstName',
      type: 'TEXT',
      sortDirection: 'Default',
      enableSorting: true,
      enableFilter: true,
      cssClass: '',
      priority: 2
    },
    {
      caption: 'Email',
      field: 'email',
      type: 'TEXT',
      sortDirection: 'Asc',
      enableSorting: false,
      enableFilter: true,
      cssClass: '',
      priority: 3


    }
  ];
  isInitialUserList = true;
  paginations: PaginationsModel = {
    recordsPerPage: 20,
    currentPage: 1,
    totalRecords: 0,
    isServerSide: true
  };
  errorFlag = false;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private stepindicatorService: StepIndicatorService,
    private utilityService: UtilityService,
    private userWizardDataService: UserWizardDataService,
    private adobeAnalyticsService: AdobeAnalyticsService,
    private pageloaderService: PageLoaderService,
    private authenticationService: AuthenticationService,
    private userWizardService: UserWizardService,
    private http: HttpClient
  ) {
    this.pivots = new Array<MobilePivotModel>();
  }

  ngOnInit() {
    this.authenticationService.setLoginSuccessUrl(this.router.routerState.snapshot.url);
    this.userWizardInfo = JSON.parse(sessionStorage.getItem('assign-wizard'));
    this.selectedUserList = [];
    this.selectedUsersIds = [];
    this.actionType = this.userWizardInfo.actionType === 'ASSIGN' ? 'Assign' : 'Un-assign';
    if (this.userWizardInfo.selectedUserList !== undefined && this.userWizardInfo.selectedUserList.length !== 0) {
      this.selectedUserList = this.userWizardInfo.selectedUserList;
    }
    if (this.userWizardInfo.selectedUsersIds !== undefined && this.userWizardInfo.selectedUsersIds.length !== 0) {
      this.selectedUsersIds = this.userWizardInfo.selectedUsersIds;
    }
    if (this.selectedUserList !== undefined && this.selectedUserList.length > 0) {
      this.continueDisable = false;
    }
    if (PIVOTS[this.userWizardInfo.previousUrl]) {
      this.pivots.push({ label: PIVOTS[this.userWizardInfo.previousUrl], routerLink: this.userWizardInfo.previousUrl });
    }
    const message = this.userWizardInfo.actionType === 'ASSIGN' ? 'Assign product licenses' : 'Un-assign product licenses';
    this.userWizardService.setMessage(message);
    this.pivots.push({ label: 'Console dashboard', routerLink: '/dashboard' });
    this.userWizardService.setPivot(this.pivots);
    if (this.userWizardInfo === null
      || !!!this.userWizardInfo.selectedProductList
      || this.userWizardInfo.selectedProductList.length <= 0
    ) {
      this.router.navigate(['/home']);
    } else {

      // document.title = 'AT&T Business Console - Manage users';
      document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
      this.stepindicatorService.setCurrentStep(this.activatedRoute.snapshot.url[0].path);

      this.user = this.authenticationService.getUser();

      this.noOfSelectedProduct = this.userWizardInfo.selectedProductList.length;
      this.serviceClientIds = [];
      this.userWizardInfo.selectedProductList.find((data) => {
        try {
          this.checkLicense += ((this.actionType === 'Assign') ? Number(data.totalLicensesAvailable) : Number(data.totalLicensesInUse));
        } catch (e) {
          console.log(e);
          this.checkLicense = 0;
        }
        this.serviceClientIds.push(data.clientId);
      });
      if (this.noOfSelectedProduct === 1) {
        this.showProductInfo = true;
        this.selectedProdDetails = this.userWizardInfo.selectedProductList[0];
      } else {
        this.showProductInfo = false;
      }

      if (this.userWizardInfo.userEmail !== undefined) {
        this.getSingleUser();
      } else {
        this.getAllUser();
      }

      this.userWizardDataService.createPageLoadProperties([],
        this.router.routerState.snapshot.url, 'Manageusers Page - Step3',
        ANALYTICS_CONSTANTS.FRIENDLY_NAME_MANAGE_USER_USERS);
    }
  }

  getSingleUser() {
    const fetchCriteria: FetchCriteriaModel = {
      limit: this.paginations.recordsPerPage,
      offset: 0,
      sortDir: 'ASC',
      sortField: 'firstName',
      searchValue: ''
    };
    this.dcmCodesSelectedProd = [];
    for (const prod of this.userWizardInfo.selectedProductList) {
      this.totalLisence += prod.totalLicensesAvailable;
      this.dcmCodesSelectedProd.push(prod.dcmCode);
    }
    this.userWizardInfo.paginations = this.paginations;
    this.userWizardInfo.selectedUsersIds = this.selectedUsersIds;
    this.userWizardDataService.setUserWizard(this.userWizardInfo);
    delete fetchCriteria.searchValue;
    this.buildrequestObj(fetchCriteria);
    this.requestObj.searchValue = this.userWizardInfo.userEmail;
    this.fetchUserDetail(this.requestObj);
  }

  getAllUser() {
    const fetchCriteria: FetchCriteriaModel = {
      limit: this.paginations.recordsPerPage,
      offset: 0,
      sortDir: 'ASC',
      sortField: 'firstName',
      searchValue: ''
    };
    this.dcmCodesSelectedProd = [];
    for (const prod of this.userWizardInfo.selectedProductList) {
      this.totalLisence += prod.totalLicensesAvailable;
      this.dcmCodesSelectedProd.push(prod.dcmCode);
    }
    this.userWizardInfo.paginations = this.paginations;
    this.userWizardInfo.selectedUsersIds = this.selectedUsersIds;
    this.userWizardDataService.setUserWizard(this.userWizardInfo);
    delete fetchCriteria.searchValue;
    this.buildrequestObj(fetchCriteria);
    this.fetchUserDetail(this.requestObj);
  }

  buildrequestObj(fetchCriteria) {
    if (this.userWizardInfo.actionType === 'ASSIGN' || this.userWizardInfo.actionType === 'assign') {
      this.requestObj = {
        'fetchCriteria': fetchCriteria,
        'withoutServiceOfferCodes': this.dcmCodesSelectedProd
      };
    } else {
      this.requestObj = {
        'fetchCriteria': fetchCriteria,
        'withSubscriptions': this.serviceClientIds,
        'licenseProvisionStatuses': ['ACTIVE']
      };
    }
  }

  fetchUserDetail(requestObj) {
    this.pageloaderService.setPageLoaderStatus(false);
    let serviceUrl = '';
    if (this.userWizardInfo.actionType === 'ASSIGN' || this.userWizardInfo.actionType === 'assign') {
      serviceUrl = this.utilityService.getEnvConfig().getUserSearch + this.user.companyId + '/employees/textSearch';
    } else {
      serviceUrl = this.utilityService.getEnvConfig().getUserSearch + this.user.companyId + '/employees/textSearch?initProps=licenses';
    }

    this.userWizardDataService
      .getUserList(serviceUrl, this.requestObj)
      .subscribe(userRespObj => {
        this.setError = false;
        this.ErrorMessage = '';
        if (userRespObj.dataJson !== undefined) {
          this.userList = [];
          for (const user of userRespObj.dataJson) {
            const tmp_usr_obj = new UserModel();
            tmp_usr_obj.clientId = user.clientId;
            tmp_usr_obj.firstName = user.firstName + ' ' + user.lastName;
            tmp_usr_obj.email = user.email;
            tmp_usr_obj.phoneNumber = user.phoneNumber;
            if (this.userWizardInfo.actionType === 'UNASSIGN' || this.userWizardInfo.actionType === 'unassign') {
              if (user.licenses[0] !== undefined && user.licenses[0].clientLicenseId !== undefined) {
                tmp_usr_obj.licenseClientId = user.licenses[0].clientLicenseId;
              } else {
                tmp_usr_obj.licenseClientId = '';
              }
            }
            if (this.selectedUsersIds.indexOf(tmp_usr_obj.clientId) === -1) {
              tmp_usr_obj.isSelected = false;
            } else {
              tmp_usr_obj.isSelected = true;
            }
            tmp_usr_obj.formProperties = [];
            this.userList.push(tmp_usr_obj);
            // tslint:disable-next-line:max-line-length
            if (!tmp_usr_obj.isSelected && this.userWizardInfo.userEmail !== undefined && tmp_usr_obj.email === this.userWizardInfo.userEmail) {
              this.radioSelections(tmp_usr_obj);
              this.totalUser = 0;
            }
          }
          if (this.selectedUsersIds !== undefined) {
            let inx = 0;
            for (const tmp_usr_obj of this.userList) {
              if (this.selectedUsersIds.indexOf(tmp_usr_obj.clientId) === -1) {
                this.userList[inx].isSelected = false;
              } else {
                this.userList[inx].isSelected = true;
                this.totalUser += 1;
              }
              inx += 1;
            }
          }
          this.paginations.totalRecords = userRespObj.totalLength;
          this.userWizardInfo.userList = this.userList;
          this.userWizardDataService.setUserWizard(this.userWizardInfo);

          this.buildGridOption();
          this.pageloaderService.setPageLoaderStatus(true);
        } else {
          this.userList = [];
          this.paginations.totalRecords = 0;
          this.buildGridOption();
          this.pageloaderService.setPageLoaderStatus(true);
        }
      }, error => {
        this.pageloaderService.setPageLoaderStatus(true);
        this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse');
        this.setErrorMessage(error);
      });

  }

  buildActionObj(type) {
    const action_obj = {
      caption: 'Select',
      field: 'isSelected',
      type: type,
      sortDirection: 'Asc',
      enableSorting: false,
      enableFilter: false,
      cssClass: 'customCell',
      priority: 1
    };
    this.columnDefinitions.unshift(action_obj);
  }

  setErrorMessage(error) {
    this.pageloaderService.setPageLoaderStatus(true);
    if (error.status === 401) {
      this.setError = true;
      this.ErrorMessage = 'Session expired, Please login again.';
      logoutCurrentUser(true);
    } else {
      this.setError = true;
      this.ErrorMessage = 'We couldn\'t complete your request. Please try again later.';
    }
    this.utilityService.loadFocusOnTop();
  }

  buildGridOption() {
    if (this.isInitialUserList) {
      if (this.userWizardInfo.source !== undefined && this.userWizardInfo.source !== null) {
        if (this.userWizardInfo.source === 'product') {
          if (this.userWizardInfo.selectedProductList !== undefined) {
            if (this.userWizardInfo.selectedProductList.length === 1) {
              this.buildActionObj('CHECKBOX');
            } else {
              this.buildActionObj('RADIO');
            }
          }
        } else if (this.userWizardInfo.source === 'user') {
          this.buildActionObj('RADIO');
        }
      } else {
        if (this.userWizardInfo.selectedProductList !== undefined) {
          if (this.userWizardInfo.selectedProductList.length === 1) {
            this.buildActionObj('CHECKBOX');
          } else {
            this.buildActionObj('RADIO');
          }
        }
      }
      const assignWizard = JSON.parse(sessionStorage.getItem('assign-wizard'));
      this.isInitialUserList = false;
      sessionStorage.setItem('assign-wizard', JSON.stringify(assignWizard));
    }
    const options = new GridOptionsModel();

    options.enableSorting = true;
    options.gridData = this.userList;
    if (this.userWizardInfo.userEmail !== undefined) {
      options.enableFiltering = false;
    } else {
      options.enableFiltering = true;
    }
    options.enableSearchLimit = true;
    options.searchLimit = 3;
    options.enableBackLink = true;
    options.backLinkText = 'View all users';
    if (this.userList.length > 0) {
      options.emptyMessage = '';
    } else if (this.userList.length === 0) {
      options.emptyMessage = 'No Records Found';
      options.showPaginationIndex = false;
      options.isEmptyMessageInRow = true;
    }
    options.columnDefinitions = this.columnDefinitions;
    options.searchDescriptions = 'If you recently uploaded bulk users they might not be available yet. Please check back soon.';
    options.searchPlaceHolder = 'Enter first or last name';
    options.Paginations = this.paginations;
    this.gridOptions = options;
  }

  radioSelections(event) {
    this.selectedUserList = [];
    this.selectedUsersIds = [];
    this.selectedUserList.push(event);
    this.selectedUsersIds.push(event.clientId);
    this.continueDisable = false;
    if (this.totalUser === 0) {
      this.totalUser = 1;
    }
    this.userWizardInfo.selectedUserList = this.selectedUserList;
  }

  checkboxSelections(event) {
    this.setError = false;
    this.continueDisable = false;
    const tmp_selected_usr_obj = event;
    if (tmp_selected_usr_obj.checkedStatus === true) {
      this.continueDisable = false;
      delete tmp_selected_usr_obj.checkedStatus;
      this.selectedUserList.push(tmp_selected_usr_obj);
      this.selectedUsersIds.push(tmp_selected_usr_obj.clientId);
      this.totalUser += 1;
    } else if (tmp_selected_usr_obj.checkedStatus === false) {
      let index = 0;
      for (const user of this.selectedUserList) {
        if (user.clientId === tmp_selected_usr_obj.clientId) {
          this.selectedUserList.splice(index, 1);
          this.selectedUsersIds.splice(index, 1);
          this.totalUser -= 1;
        }
        index += 1;
      }
      if (this.selectedUserList.length === 0) {
        this.continueDisable = true;
      }
    }
    let lengthToCheck = 0;
    if (this.selectedProdDetails.totalLicensesAvailable < ASSIGN_USER_LIMIT) {
      lengthToCheck = this.selectedProdDetails.totalLicensesAvailable;
    } else {
      lengthToCheck = ASSIGN_USER_LIMIT;
    }
    // tslint:disable-next-line:max-line-length
    if (this.userWizardInfo.actionType === 'ASSIGN' && this.selectedProdDetails !== undefined && !!this.selectedProdDetails.totalLicensesAvailable
      && this.selectedUserList.length > lengthToCheck) {
      this.continueDisable = true;
      this.setError = true;
      this.ErrorMessage = 'You have ' +
        this.totalLisence + ' licenses available and you\'ve selected ' + this.totalUser + 'users.';
      this.utilityService.loadFocusOnTop();
      this.errorFlag = true;
    }
    if (this.userWizardInfo.actionType === 'UNASSIGN' && this.selectedUserList.length > ASSIGN_USER_LIMIT) {
      this.continueDisable = true;
      this.setError = true;
      this.ErrorMessage = 'You have ' +
        this.totalLisence + ' licenses available and you\'ve selected ' + this.totalUser + 'users.';
      this.utilityService.loadFocusOnTop();
      this.errorFlag = true;
    }
    this.userWizardInfo.selectedUserList = this.selectedUserList;
  }

  handleError(error) {
    throw error;
  }

  back() {
    this.userWizardInfo.paginations.currentPage = 1;
    this.userWizardDataService.setUserWizard(this.userWizardInfo);
    this.router.navigate(['/manageUsers/products'], { relativeTo: this.activatedRoute });
  }

  next() {
    this.userWizardInfo.paginations.currentPage = 1;
    this.userWizardDataService.setUserWizard(this.userWizardInfo);
    // tslint:disable-next-line:max-line-length
    if (this.selectedProdDetails !== undefined && !!this.selectedProdDetails.totalLicensesAvailable && this.userWizardInfo.actionType === 'ASSIGN') {
      if (this.selectedUserList.length <= this.selectedProdDetails.totalLicensesAvailable) {
        this.processSelectedUsers();
      } else {
        this.setError = true;
        this.ErrorMessage = 'You have ' +
          this.totalLisence + ' licenses available and you\'ve selected ' + this.totalUser + 'users.'; this.utilityService.loadFocusOnTop();
      }
    } else {
      this.processSelectedUsers();
    }
  }

  processSelectedUsers() {
    delete this.userWizardInfo.selectedUserList;
    this.userWizardDataService.setUserWizard(this.userWizardInfo);
    this.userWizardInfo.selectedUserList = this.selectedUserList;
    this.userWizardInfo.selectedUsersIds = this.selectedUsersIds;
    this.userWizardInfo.paginations = this.paginations;
    this.userWizardDataService.setUserWizard(this.userWizardInfo);
    this.router.navigate(['/manageUsers/review']);
  }

  gridEventChanges(fetchCriteria: FetchCriteriaModel) {
    fetchCriteria.sortDir = (!!fetchCriteria.sortDir) ? fetchCriteria.sortDir : 'ASC';
    fetchCriteria.sortField = (!!fetchCriteria.sortField) ? fetchCriteria.sortField : 'firstName';
    if (!!fetchCriteria.searchValue) {
      this.requestObj.searchValue = fetchCriteria.searchValue;
      delete fetchCriteria.searchValue;
    } else {
      delete this.requestObj.searchValue;
    }
    this.requestObj.fetchCriteria = fetchCriteria;
    this.fetchUserDetail(this.requestObj);
  }


  ngOnDestroy() {
    this.pageloaderService.setPageLoaderStatus(true);
  }
}
